"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptimizedCovers = void 0;
var _ = __importStar(require("underscore"));
function getOptimizedCovers(covers, desiredSize) {
    // coversBySize is now an array of covers, from smallest to largest
    var coversBySize = _.sortBy(covers, 'width');
    // Start with the biggest cover
    // Copy object with Object.assign() so we dont damage reference
    var optimizedCover = Object.assign({}, _.last(coversBySize));
    if (optimizedCover && optimizedCover.href) {
        var legacyToOptimizedImageHostsMap = {
            'https://img1.od-cdn.com/': 'https://ic.od-cdn.com/resize',
            'https://images.overdrivechina.cn/': 'https://images.overdrivechina.cn/resize'
        };
        var hostMapKey = _.find(Object.keys(legacyToOptimizedImageHostsMap), function (legacy) { return optimizedCover.href.startsWith(legacy); });
        if (hostMapKey) {
            // look up the corresponding optimized root, e.g. https://img1.od-cdn.com/ -> https://ic.od-cdn.com/resize
            var optimizedImageHost = legacyToOptimizedImageHostsMap[hostMapKey];
            var optimizations = 'type=auto'; // format = auto -> use webp if the device supports it
            var path = '';
            if (typeof document === 'undefined') {
                // node.js usage should be fine with the URL api
                var url = new URL(optimizedCover.href);
                path = url.pathname;
            }
            else {
                // hack to get url pathname since IE doesn't support the URL api.  I didn't want to add a polyfill
                var a = document.createElement('a');
                a.href = optimizedCover.href;
                path = a.pathname;
                if (!path.startsWith('/')) { // browsers are inconsistent about whether the pathname includes a leading slash, but the cachefly api requires exactly one on the url param
                    path = "/".concat(path);
                }
            }
            var encodedSrcUrl = encodeURIComponent(path);
            var coverHrefWithoutSize = "".concat(optimizedImageHost, "?").concat(optimizations, "&url=").concat(encodedSrcUrl, "&stripmeta=true");
            optimizedCover.href = "".concat(coverHrefWithoutSize, "&width=").concat(desiredSize);
            optimizedCover.srcset = "".concat(coverHrefWithoutSize, "&width=").concat(Math.floor(desiredSize * 2), " 2x, ") +
                "".concat(coverHrefWithoutSize, "&width=").concat(Math.floor(desiredSize * 1.5), " 1.5x, ") +
                "".concat(coverHrefWithoutSize, "&width=").concat(desiredSize, " 1x");
            return optimizedCover;
        }
    }
    return _.find(coversBySize, function (cover) { return cover.width >= desiredSize; }) ||
        _.last(coversBySize); // finds the first cover that is big enough
}
exports.getOptimizedCovers = getOptimizedCovers;

//# sourceMappingURL=getOptimizedCover-ts.js.map

//# sourceMappingURL=getOptimizedCover-ts.js.map
